




















import { State, Getter, Action } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { SortOrder } from '@/enums/SortOrder';
import { Debounce } from '@/functions/debounce';
import { Searchable } from '@/mixins/searchable';
import { i18n } from '@/localization';

@Component({
  components: {
    PagePresetDashboard: () => import('@/layouts/presets/dashboard.vue'),
    TableBase: () => import('@/components/table/base.vue'),
    IndexSearch: () => import('@/components/parts/IndexSearch.vue'),
  },
})
export default class PageTransportCostTranslations extends Searchable<TransportCost> {
  @Getter('workspace/selected') workspace!: Workspace;

  @Getter('transport-costs/all') transportCosts!: TransportCost[];

  @Action('transport-costs/index') indexTransportCosts!: ({ query, workspaceId }: { query?: IndexQuery<TransportCost>; workspaceId: number }) => Promise<{ total: number; data: TransportCost[] }>;

  i18n: string = 'views.transport-costs.index';

  searchItemsProperty = 'transportCosts';

  defaultSortQuery = { type: SortOrder.ASC, id: SortOrder.ASC };

  tableLayout = {
    settings: {
      locale_path: `${this.i18n}.table`,
      max_height: 'calc(100% - 136px)',
      clickable: true,
    },
    structure: [
      {
        key: 'type',
        value: (model: TransportCost) => i18n.t(`transport-costs.types.${model.type}`),
      },
      {
        key: 'price',
      },
    ],
  };

  get defaultSearchQuery(): Query<TransportCost> {
    return { or: { type: [`like:*${this.searchText}*`, `match:${this.searchText}`] } };
  }

  @Debounce(500)
  handleSearch(searchText: string) {
    this.searchText = searchText;
    this.indexTransportCosts({ query: { q: this.searchQuery, per_page: 20, s: this.sortQuery }, workspaceId: this.workspace.id });
  }

  handleSort(item: any) {
    this.sorting = item;
    this.indexTransportCosts({ query: { q: this.searchQuery, per_page: 20, s: this.sortQuery }, workspaceId: this.workspace.id });
  }

  loadMore() {
    this.indexTransportCosts({ query: { q: this.searchQuery, after: this.lastAfter, s: this.sortQuery }, workspaceId: this.workspace.id });
  }
}
